/**
 * @typedef {{ first: string, last: string }} FullNameParts
 *
 * @param {string | null | undefined} fullName Full name in "Last, First" format.
 * @returns {FullNameParts}
 */
export const splitFullName = (fullName) => {
	if (typeof fullName !== 'string' || fullName.length === 0) {
		return { first: '', last: '' };
	}
	const [last = '', first = ''] = fullName.split(', ');
	return { first, last };
};
